import React from 'react';

import { Wrapper } from './PagePaddingContainer.styles';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

export const PagePaddingContainer: React.FC<IProps> = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};
